import { IApplicationState } from '../../types/redux';
import { getKey } from '../../utils/selected';

export const selectIsEntitySelected = (entityId: number, entityType: string) => (state: IApplicationState) => {
  const key = getKey(entityId, entityType);

  return Boolean(state.selected[key]);
};
